'use strict';

/**
 * Layout for a conversation
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

// var DetailView = require('../partials/detail');
var LayoutView = require('base/Colido.LayoutView');
var ConversationPostsListView = require('modules/community/views/partials/conversation-posts');
var ConversationPostsErrorView = require('modules/community/views/partials/conversation-posts-error');
var GroupMembersView = require('modules/community/views/partials/group-members');
var GroupActionsView = require('modules/community/views/partials/group-actions');
var ShareSetsView = require('modules/community/views/partials/share-sets');

var template = require('modules/community/templates/layout/conversation.hbs');

var ConversationLayout = LayoutView.extend({
    template: template,

    className: function() {
        return 'conversation-container conversation-type-' + this.model.get('type');
    },

    regions: {
        postsRegion: '.conversation-posts-region',
    },

    ui: {
        'closeLink': 'a.close, a.btn-back',
        'form': '.conversation-form',
        'messageInput': '[name="messageInput"]',
        'acceptContact': '[data-action="accept-contact"]',
        'removeContact': '[data-action="remove-contact"]',
        'showShareMenu': '[data-action="show-share-menu"]',
    },

    events: {
        'click @ui.closeLink': 'close',
        'submit @ui.form': 'onSubmit',
        'input @ui.messageInput': 'fixTextareaSize',
        'keyup @ui.messageInput': 'checkEnterKeySubmit',
        'click @ui.acceptContact': 'acceptContact',
        'click @ui.removeContact': 'removeContact',
        'click @ui.showShareMenu': 'toggleShareMenu',
    },

    modelEvents: {
        'change:unreadPosts': 'resetUnreadPosts',
    },

    initialize: function (options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        this.posts = this.model.posts;

        this.conversationPostsView = new ConversationPostsListView({
            collection: this.posts,
            sortDefault: 'created.asc',
            reorderOnSort: true,
        })

        this.postsRegion.on('show', function(){
            this.postsRegion.$el.removeClass('loading');
        }.bind(this))

        if (this.model.get('type') === 'contact') {
            this.listenTo(this.model.get('contact'), 'remove', function(){
                App.router.navigate('community/contacts', {trigger: true, replace: true});
            });
            this.listenTo(this.model.get('contact'), 'change:accepted', function(model, acceptedStatus){
                if (acceptedStatus === 'YES') {
                    App.router.navigate('/community/contacts', {trigger: true, replace: true}); //dirty hack to refresh the current view
                    App.router.navigate(this.model.get('url'), {trigger: true, replace: true});
                }
            }.bind(this));
        }
    },

    onRender: function () {
        if (this.model.get('type') === 'group' || this.model.get('type') === 'broadcast') {
            this.addRegion('groupMembersRegion', '.group-members-region');
            this.addRegion('groupActionsRegion', '.group-actions-region');

            var groupMembersView = new GroupMembersView({model: this.model.get('group')});
            this.groupMembersRegion.show(groupMembersView);

            var groupActionsView = new GroupActionsView({model: this.model.get('group')});
            this.groupActionsRegion.show(groupActionsView);

            this.listenTo(groupActionsView, 'group:left', function(){
                App.router.navigate('community/groups', {trigger: true, replace: true});
            });
            this.listenTo(groupActionsView, 'group:deleted', function(){
                App.router.navigate('community/broadcasts', {trigger: true, replace: true});
            });
        }

        if (App.CollectionModule.catalogs.getActiveCatalog() && this.$('.share-sets-region').length) {
            this.addRegion('shareSetsRegion', '.share-sets-region');

            this.shareSetsRegion.show(new ShareSetsView({
                collection: App.CollectionModule.catalogs.getActiveCatalog().sets,
                conversation: this.model,
            }));
        }
    },

    onAttach: function () {
        if (!browser.isMobile) {
            this.ui.messageInput.focus();
        }

        //fetch and render posts collection view after extra content is visible
        setTimeout(function(){
            this.posts.fetch({
                success: function() {
                    if (this.isDestroyed) { return; }

                    this.postsRegion.show(this.conversationPostsView);
                    this.scrollToBottom();

                    this.listenTo(this.conversationPostsView, 'add:child', this.scrollToBottom.bind(this));
                }.bind(this),
                error: function (model, response, options) {

                    this.postsRegion.show(new ConversationPostsErrorView({}));

                }.bind(this),
            });
        }.bind(this), 500);
    },

    onResize: function() {
        this.fixTextareaSize(this.ui.messageInput);
    },

    close: function(event) {
        event ? event.preventDefault() : null;

        App.router.navigate(this.getOption('closeUrl'), {trigger: true, replace: true});
    },

    onSubmit: function(event) {
        event ? event.preventDefault() : null;

        var messageText = this.ui.messageInput.val().replace(/\n+$/, '').trim();

        this.ui.messageInput.val('');

        if (messageText) {
            var message = {
                type: 'text',
                data: messageText,
            };

            App.radio('community').execute('send:message:to:conversation', this.model, message);
        }

        this.ui.messageInput.focus();
    },

    scrollToBottom: function(){
        if (this.postsRegion.$el.length) {
            this.postsRegion.el.scrollTop = this.postsRegion.el.scrollHeight;
        }
    },

    checkEnterKeySubmit: function(event) {
        if (event.which === App.keys.RETURN && event.shiftKey === false) {
            this.ui.form.submit();
        }

        this.fixTextareaSize(event);
    },

    resetUnreadPosts: function(model) { //while a conversation view is open, reset unreadPosts count to 0
        if (model.get('unreadPosts') > 0) {
            model.save({unreadPosts: 0}, {patch: true});
        }
    },

    acceptContact: function(event) {
        var button = $(event ? event.currentTarget : null);

        App.radio('community').execute('accept:contact', this.model.get('contact'), {
            wait: true,
            error: function() {
                button.prop('disabled', false).removeClass('is-loading');
            }.bind(this),
        });

        button.prop('disabled', true).addClass('is-loading');
    },

    removeContact: function(event) {
        var contactName = this.model.get('name') || this.model.get('email');
        if (!window.confirm(App.t('community::contact:action:confirm-delete', {name: contactName}))) {
            return;
        }

        var button = $(event ? event.currentTarget : null);

        App.radio('community').execute('delete:contact', this.model.get('contact'), {
            wait: true,
            error: function() {
                button.prop('disabled', false).removeClass('is-loading');
            }.bind(this),
        });

        button.prop('disabled', true).addClass('is-loading');
    },

    toggleShareMenu: function(event) {
        event.preventDefault();
        if (this.ui.form.hasClass('show-share-menu')) {
            this.hideShareMenu();
        } else {
            this.showShareMenu();

            setTimeout(function(){
                $('body').one('click', this.hideShareMenu.bind(this));
            }.bind(this), 0)
        }
    },

    showShareMenu: function(event) {
        this.ui.form.addClass('show-share-menu');
    },

    hideShareMenu: function() {
        this.ui.form.removeClass('show-share-menu');
    },
});

module.exports = ConversationLayout;